import React from 'react';
import PropTypes from 'prop-types';
import Pagination from '../../../../shared/components/pagination/Pagination';

const ExpenesTablePagination = ({
  totalProjects,
  perPage,
  currentPage,
  updatePagination,
}) => (
  <Pagination
    itemsCount={totalProjects}
    itemsToShow={perPage}
    pageOfItems={currentPage}
    onChangePage={updatePagination}
  />
);

ExpenesTablePagination.propTypes = {
  totalProjects: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  updatePagination: PropTypes.func.isRequired,
};

export default ExpenesTablePagination;
